<template>
  <v-system-bar style="width: 100% !important;" :class="getClasses" :dark="themeLight" app>

    <span :class="spanClass">{{ day }}</span>
    <span :class="spanClass">{{ date }}</span>
    <span :class="spanClass">{{ hijri }}</span>
    <v-spacer></v-spacer>
    <span>{{ time }}</span>
    <template v-if="$root.canFullscreen && !$vuetify.breakpoint.xsOnly">
      <app-system-bar-btn
          v-if="!$root.AppFullscreen"
          @click="$root.setFullscreen(!0)">
        <v-icon>mdi-fullscreen</v-icon>
      </app-system-bar-btn>
      <app-system-bar-btn
          v-if="$root.AppFullscreen"
          @click="$root.setFullscreen(!1)">
        <v-icon>mdi-fullscreen-exit</v-icon>
      </app-system-bar-btn>
    </template>
    <app-system-bar-btn @click="$root.themeDark = !$root.themeDark">
      <v-icon>mdi-palette</v-icon>
    </app-system-bar-btn>
    <app-system-bar-btn
        v-if="isLogin"
        @click="closeWindow">
      <v-icon>mdi-close</v-icon>
    </app-system-bar-btn>
  </v-system-bar>
</template>

<script>

export default {
  name: 'SystemBar',
  data() {
    const meta = document.head.querySelector('meta[name="csrf-token"]');
    return {
      hijri: null,
      date: null,
      time: null,
      time1: null,
      day: null,
      spanClass: 'pe-2',
      appName: 'مركز تواصل الشرمي',
    };
  },
  computed: {
    getClasses() {
      return {
        primary: true,
        'darken-2': this.themeLight,
        'darken-1': this.themeDark
      };
    },
    logoColor() {
      return this.themeDark ? 'gray' : 'transparent';
    },
  },
  created() {
    let time, time1, date, day, hijri;
    setInterval(() => {
      time = this.$moment().format('hh:mm:ss a');
      time1 = this.$moment().format('HH:mm:ss');
      date = this.$moment().format('YYYY/MM/DD');
      day = this.$moment().format('dddd');
      hijri = this.$moment().format('iYYYY/iMM/iDD');

      this.date = `${date}`;
      this.hijri = `${hijri}`;
      this.time = time;
      this.time1 = time1;
      this.day = day;
    }, 1000);
  },
  methods: {
    closeWindow() {
      this.confirm(this.$t('messages.sure_logout'), () => {
        this.logoutUser(!0);
      });
    }
  },
  mounted() {
    // console.log(this.$moment().format('ddd'));
    // console.log(this.$moment().format('dddd'));
    // console.log(this.$moment().format('ddddd'));
  },

};
</script>

<style scoped>
</style>
